<script setup lang="ts">
const props = defineProps<{ productGroup: CampaignProductGroup, listIndex?: number }>()
const expanded = ref(false)
const gtm = useGtm()

function handleToggleSupplier() {
  if (!expanded.value) {
    gtm?.trackEvent({
      event: 'view_supplier_options',
      supplier_name: props.productGroup.suppliers[0].supplier.name,
      page_section: 'campaigns',
      item_id: props.productGroup.suppliers[0]?.items[0]?.handle ?? '',
      item_name: props.productGroup.name,
    })
  }
  expanded.value = !expanded.value
}
</script>

<template>
  <SearchCard v-if="productGroup?.suppliers?.length > 0">
    <ProductItem :product="productGroup.suppliers.at(0)!" :list-index="listIndex" />
    <template v-if="expanded">
      <template v-for="supplier of productGroup.suppliers.slice(1)" :key="supplier.name">
        <v-divider />
        <ProductItem :product="supplier" :list-index="listIndex" />
      </template>
    </template>
    <SuppliersList
      v-if="productGroup.suppliers.length > 1"
      :supplier-shown="expanded"
      :suppliers="productGroup.suppliers.slice(1)"
      @toggle-supplier="handleToggleSupplier"
    />
  </SearchCard>
</template>
